import React from 'react';
import TableListExpert from "./TableListExpert"

const dashBoardExpert = () => {
  return (
    <section>

    <TableListExpert/>
    </section>
  )
}

export default dashBoardExpert